import { render, staticRenderFns } from "./DialogSalesInvoiceReminder.vue?vue&type=template&id=76974416"
import script from "./DialogSalesInvoiceReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSalesInvoiceReminder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports